import type { UserProfile } from "./user";

export const UnauthorizedZephrUserProfile: UserProfile = {
  trackingId: "",
  first_name: "",
  last_name: "",
  is_logged_in: false,
  is_pro: false,
  details: {},
  is_academic_user: false,
};

export const UnauthorizedZephrAccessDetails: Window["Zephr"] = {
  accessDetails: {
    isAuthenticated: false,
    activeProducts: [],
  },
  showPaywall: typeof window !== "undefined" ? window.Zephr?.showPaywall : null,
  openModal: typeof window !== "undefined" ? window.Zephr?.openModal : () => {},
  closeModal:
    typeof window !== "undefined" ? window.Zephr?.closeModal : () => {},
};
